import { IAppointment } from '@pia/pia.shared';
import moment from 'moment';

export function filterTodayAppointments(appointments: IAppointment[]) {
  return (
    appointments &&
    appointments.filter(
      appointment =>
        !appointment.archived && moment(new Date(appointment.startDate)).isSame(moment().startOf('day'), 'd')
    )
  );
}
